import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AuthService } from '../../services/components/auth.servicice';
import { Router } from '@angular/router';
import { Sit2Service } from '../../services/http/sit2.service';
import { HeaderAuthComponent } from '../../shared/components/header_auth/header_auth.component';
import { AgregarDescuentoComponent } from '../agregar_descuento/agregar_descuento.component';
import { ObligacionesPendientesComponent } from '../obligaciones_pendientes/obligaciones_pendientes.component';
import { DeclaracionesPresentadasICAComponent } from '../declaraciones_presentadas_ica/declaraciones_presentadas_ica.component';

declare let gtag: Function;

@Component({
  selector: 'app-industria-y-comercio',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, HeaderAuthComponent, AgregarDescuentoComponent, ObligacionesPendientesComponent, DeclaracionesPresentadasICAComponent],
  templateUrl: './industriaycomercio.component.html',
  styleUrl: './industriaycomercio.component.scss'
})

export class IndustriaYComercioComponent implements OnInit {
  @ViewChild(AgregarDescuentoComponent) agregarDescuentoComponent!: AgregarDescuentoComponent;

  showViewHTMLComponent = false;
  listActividades = [];
  tabs = [true, false];

  constructor(private router: Router,
    private sit2Service: Sit2Service,
    private authService: AuthService) {
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/login']);
      return;
    } else {
      this.showViewHTMLComponent = true;
    }
  }

  ngOnInit() {
    try {
      window.scrollTo(0, 0);
    } catch (error) {
      console.error(error);
    }

    if (typeof gtag === 'function') {
      try {
        gtag('event', 'page_view', { page_path: '/OficinaVirtualSIT2/industria_y_comercio' });
      } catch (err) {}
    }else{}

  }

  agregarDescuento(){
    this.agregarDescuentoComponent.enviar();
  }

  changeTab(item: number){
    if(item == 1){
      this.tabs[0] = true; 
      this.tabs[1] = false; 
    }else if(item == 2){
      this.tabs[0] = false; 
      this.tabs[1] = true; 
    }
  }
}
